import { InvestorFacade } from 'src/app/store/investor/facade/investor.facade';
import * as utilitiesActions from './../actions/utilities.actions';
import { Injectable } from "@angular/core";
import { IAppState } from "../../state/app.state";
import { Store, select } from "@ngrx/store";
import { Observable } from 'rxjs';
import { Country } from 'src/app/models/country';
import * as fromUtilities from '../selectors/utilities.selectors';
import { take, tap, map } from 'rxjs/operators';

@Injectable()
export class UtilitiesFacades {


    constructor(private store: Store<IAppState>) { }

    getCountryList(): Observable<Country[]> {
        this.store.pipe(select(fromUtilities.getCountryList, take(1)))
            .subscribe((countryList: Country[]) => {
                if (countryList.length === 0) {
                    this.loadCountryList();
                }
            });
        return this.store.pipe(select(fromUtilities.getCountryList));

    }
    loadCountryList() {
        this.store.dispatch(new utilitiesActions.LoadCountryList);
    }


}
